import { usePortal } from "./usePortal";
import { useBrandColor } from "../../lib/brandTheme";

/* Client portal: paint the app's primary token with the client's (or main client's) brand colour. Renders nothing. */
export function PortalTheme() {
  const { me } = usePortal();
  useBrandColor(me?.branding?.primary_color || "");
  return null;
}
